import React, { useState, useEffect } from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import Table from 'react-bootstrap/Table';
import { useParams } from 'react-router-dom';
import Wrapper from '../../components/Wrapper';
import axiosInstance from '../../utils/axios';
import { getRole } from '../../utils/role';

const sizeUnits = [
    'sq mtr', 'Acres', 'Hectare', 'Bigha', 'Gaj', 'Kanal', 'Biswa', 'Dismil', 'Killa',
    'Marla', 'Nali', 'Guntha', 'Square Karam', 'Ankanam', 'Gajam', 'Chatak',
    'Dhur', 'Perch', 'Lessa', 'Murabba', 'Biswa Kacha', 'Pura'
];


const summaryFields = [
    { name: 'yield date', label: 'yield_date', placeholder: 'Enter Yield Date', type: 'date', disabled: false },
    { name: 'crop', label: 'crop', placeholder: 'Enter Crop', type: 'text', disabled: false },
    { name: 'profit', label: 'profit', placeholder: 'Profit will be calculated', type: 'number', disabled: true },

    { name: 'area', label: 'area', placeholder: 'Enter Area', type: 'number', disabled: false },
  
    { name: 'area unit', label: 'area_unit', placeholder: 'Enter Area Unit', type: 'text', option: sizeUnits, disabled: false },
    { name: 'total cost', label: 'total_cost', placeholder: 'Total Cost will be calculated', type: 'number', disabled: true },

    { name: 'Sale price of 1 quintal', label: 'per_quintal_sale_price', placeholder: 'Enter Sale Price of 1 quintal', type: 'number', disabled: false },
    { name: 'total quanity', label: 'total_quantity', placeholder: 'Enter Total Quantity', type: 'number', disabled: false },
    { name: 'total revenue', label: 'total_revenue', placeholder: 'Total Revenue will be calculated', type: 'number', disabled: true },

    { name: 'yield per unit', label: 'yield_per_unit', placeholder: 'Enter Yield Per Unit', type: 'number', disabled: false },
    { name: 'remarks', label: 'remarks', placeholder: 'Enter Remarks', type: 'text', disabled: false },
];


const practiceFields = [
    { name: 'fertilizer name', label: 'fertilizer_name', placeholder: 'Enter Fertilizer Name', type: 'text', disabled: false },
    { name: 'total quantity', label: 'total_quantity', placeholder: 'Enter Total Quantity', type: 'number', disabled: false },
    { name: 'per unit cost', label: 'per_unit_cost', placeholder: 'Per Unit Cost will be calculated', type: 'number', disabled: true },

    { name: 'cost of bag', label: 'cost_of_bag', placeholder: 'Enter Cost Of One Bag', type: 'number', disabled: false },
    { name: 'quantity in bag', label: 'quantity_in_bag', placeholder: 'Enter Quantity In Bag', type: 'number', disabled: false },
    { name: 'total cost', label: 'total_cost', placeholder: 'Total Cost will be calculated', type: 'number', disabled: true },
];

function ViewPractice() {
    const { practiceId } = useParams();
    const [practiceDetails, setPracticeDetails] = useState({});
    const [practiceList, setPracticeList] = useState([]);
    const role = getRole();

    useEffect(() => {
        const fetchData = async (id) => {
            try {
                let url = '';
                if (role === 'FIELD_OFFICER') {
                    url = `/field-officer/practice-details/${id}`;
                } else {
                    url = `/super-admin/practice-details/${id}`;
                }

                const response = await axiosInstance.get(url);
                console.log(response);
                setPracticeList(response.data.data.practicesData || []);
                setPracticeDetails(response.data.data.practicesDetails?.[0] || {});
            } catch (error) {
                console.log(error);
            }
        }

        fetchData(practiceId)
    }, [practiceId,role]);

    return (
        <Wrapper>
            <h1 className='pt-4'>View Practice</h1>
            <Row className='g-3'>
                {/* Basic Details Card */}
                <Col lg={12}>
                    <Card>
                        <h4>Basic Details</h4>
                        <br />
                        <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                            <Table responsive bordered>
                                <thead>
                                    <tr>
                                        <th>Name</th>
                                        <th>Value</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {summaryFields.map((field, index) => (
                                        <tr key={`summary-field` + index}>
                                            <td className="text-capitalize">{field.name}</td>
                                            <td>{practiceDetails[field.label] || '-'}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                        </div>
                    </Card>
                </Col>

                {/* Practice Details List */}
                <Col lg={12}>
                    <Card>
                        <h4>List of Practice Details</h4>
                        <span><i>List of all the practices added.</i></span>
                        <br />
                        {(practiceList.length === 0) ? (
                            <div className="text-center"><h5>No Practice Details Added</h5></div>
                        ) : (
                            <Table responsive striped bordered>
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        {practiceFields.map((field, index) => (
                                            <th key={`practice-list` + index} className="text-capitalize">{field.name}</th>
                                        ))}
                                    </tr>
                                </thead>
                                <tbody>
                                    {practiceList.map((practice, index) => (
                                        <tr key={index}>
                                            <td>{index + 1}</td>
                                            {practiceFields.map((field, idx) => (
                                                <td key={idx}>{practice[field.label]}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                        )}
                    </Card>
                </Col>
            </Row>
        </Wrapper>
    );
}

export default ViewPractice;